document.addEventListener('DOMContentLoaded', () => {
  const policyBody = document.querySelector('.shopify-policy__body');
  if (!policyBody) return;

  const headings = Array.from(policyBody.querySelectorAll('h1, h2, h3, h4, h5, h6'));
  const chapters = headings.filter((heading) => heading.tagName === 'H1');
  const originalIds = new WeakMap();
  const idCounts = new Map();

  headings.forEach((heading) => {
    if (!heading.id) return;

    const originalId = heading.id;
    const count = (idCounts.get(originalId) || 0) + 1;
    idCounts.set(originalId, count);
    originalIds.set(heading, originalId);

    if (count > 1) {
      heading.id = `${originalId}-${count}`;
    }
  });

  policyBody.querySelectorAll('a[href*="#"]').forEach((link) => {
    let anchor;

    try {
      anchor = decodeURIComponent(new URL(link.href, window.location.href).hash.slice(1));
    } catch (error) {
      return;
    }

    if (!anchor) return;

    let chapterIndex = -1;
    chapters.forEach((chapter, index) => {
      if (chapter.compareDocumentPosition(link) & Node.DOCUMENT_POSITION_FOLLOWING) {
        chapterIndex = index;
      }
    });

    if (chapterIndex < 0) return;

    const chapter = chapters[chapterIndex];
    const nextChapter = chapters[chapterIndex + 1];
    const target = headings.find((heading) => {
      const followsChapter = chapter.compareDocumentPosition(heading) & Node.DOCUMENT_POSITION_FOLLOWING;
      const precedesNextChapter =
        !nextChapter || heading.compareDocumentPosition(nextChapter) & Node.DOCUMENT_POSITION_FOLLOWING;

      return followsChapter && precedesNextChapter && originalIds.get(heading) === anchor;
    });

    if (target) {
      link.setAttribute('href', `#${target.id}`);
    }
  });
});
